import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers'

import type { Entity } from '@models/Entity'

import type { HoofdleidingProject } from '../../../../hoofdleiding/project/types/HoofdleidingProject'
import { StyledError } from '../../../../theme/components/StyledError'
import { useCreateSubprocesForEntity } from '../../hooks/useCreateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import { generateBodemDeadline } from '../../util/subproces-bodem-util'

interface Props {
  entity: Entity
  project: HoofdleidingProject
  onClose: () => void
}

export const CreateBodem = ({ entity, project, onClose }: Props) => {
  const { mutate: createSubprocesForEntity, error } =
    useCreateSubprocesForEntity()

  const [dueDate] = useState<Date>(() =>
    generateBodemDeadline('samenstellen_aanvraag'),
  )

  const onSubmitClick = () => {
    const proces: Partial<Subproces> = {
      type: 'bodem',
      assignedTo: project.combi,
      status: 'samenstellen_aanvraag',
      dueDate: dueDate.toISOString(),
    }

    const body = {
      entity,
      subprocesInfo: proces,
    }

    createSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Grid container spacing={1}>
          <Grid size={{ xs: 6 }}>
            <TextField
              disabled
              value={project.combi}
              variant="standard"
              label="Toegewezen aan"
              sx={{ width: '100%' }}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="Deadline voor samenstellen"
              value={dueDate}
              disabled={true}
              slotProps={{
                field: { clearable: true },
                textField: {
                  variant: 'standard',
                  sx: { pr: 1 },
                  fullWidth: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
